export interface ICatalogObjectVariantsOption {
  name: string;
  thumbnailRef : string;
  imageRef : string;
}

export class CatalogObjectVariantsOption
implements ICatalogObjectVariantsOption {
  name: string = '';
  thumbnailRef: string = '';
  imageRef : string = '';
}
